
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("fRcce", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "getBuildInfoFromKey", () => $6a42ab2e996003d0$export$38ac5ad36585402e);
$parcel$export(module.exports, "getEndpointUrl", () => $6a42ab2e996003d0$export$c54f5a49b5be9709);
$parcel$export(module.exports, "default", () => $6a42ab2e996003d0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6eHOp = parcelRequire("6eHOp");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $1EoGg = parcelRequire("1EoGg");

var $3hRxq = parcelRequire("3hRxq");

var $lopBx = parcelRequire("lopBx");

var $kyq27 = parcelRequire("kyq27");
// 10 min polling interval
const $6a42ab2e996003d0$var$DEFAULT_POLLING_INTERVAL = 600000;
const $6a42ab2e996003d0$var$DEBUG_MODE_POLLING_INTERVAL = 10000;
const $6a42ab2e996003d0$var$storageProvider = (0, $3hRxq.createLocalStorageProvider)('', false);
const $6a42ab2e996003d0$var$getDebugModeFromLocalStorage = ()=>{
    try {
        let isDebugModeSetInLocalStorage;
        if ((0, $4cTDP.fg)('jfp-vulcan-browser-storage-migration')) isDebugModeSetInLocalStorage = $6a42ab2e996003d0$var$storageProvider.get('remote-actions-debug-mode');
        else isDebugModeSetInLocalStorage = localStorage.getItem('remote-actions-debug-mode');
        return isDebugModeSetInLocalStorage === 'true';
    } catch (e) {
        return false;
    }
};
const $6a42ab2e996003d0$var$getDebugModeProps = (isRemoteActionsDebugMode)=>{
    if (isRemoteActionsDebugMode) return {
        product: 'jira.preview',
        pollingInterval: $6a42ab2e996003d0$var$DEBUG_MODE_POLLING_INTERVAL
    };
    return {
        product: 'jira',
        pollingInterval: $6a42ab2e996003d0$var$DEFAULT_POLLING_INTERVAL
    };
};
const $6a42ab2e996003d0$var$matchBuildKey = (buildKey, buildKeyPattern)=>{
    const buildNumber = buildKey.match(buildKeyPattern);
    if (buildNumber) return parseInt(buildNumber[1], 10);
    throw new Error('Invalid build key');
};
const $6a42ab2e996003d0$export$38ac5ad36585402e = (buildKey)=>{
    if (buildKey === 'JF-TEST') return {
        buildNumber: Number.MAX_VALUE,
        buildType: 'local'
    };
    if (buildKey.startsWith('MRJF-BB')) return {
        buildNumber: Number.MAX_VALUE,
        buildType: 'branch'
    };
    if (buildKey.startsWith('MRJF-PROD-ALT')) return {
        buildNumber: $6a42ab2e996003d0$var$matchBuildKey(buildKey, /^MRJF-PROD-ALT-(\d+)(-\w+)?$/),
        buildType: 'alt'
    };
    if (buildKey.startsWith('MRJF-PROD-HOTFIX')) return {
        buildNumber: $6a42ab2e996003d0$var$matchBuildKey(buildKey, /^MRJF-PROD-HOTFIX-(\d+)(-\w+)?$/),
        buildType: 'hotfix'
    };
    return {
        buildNumber: $6a42ab2e996003d0$var$matchBuildKey(buildKey, /^MRJF-PROD-(\d+)(-\w+)?$/),
        buildType: 'prod'
    };
};
const $6a42ab2e996003d0$var$fireLifecycleAnalytics = (analyticsEvent, eventAction, attributes)=>{
    if ((0, $4cTDP.fg)('remote-actions-lifecycle-analytics_9n9tr')) (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, `remoteAction ${eventAction}`, {
        source: 'remoteActions',
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        frontendVersion: window.BUILD_KEY,
        ...attributes
    });
};
const $6a42ab2e996003d0$export$c54f5a49b5be9709 = (isStaging, isFedrampPerimeter)=>{
    if (isFedrampPerimeter) {
        if (isStaging) return 'https://update-remote-action.stg.frontend.cdn.atlassian-us-gov-mod.com/assets';
        return 'https://update-remote-action.frontend.cdn.atlassian-us-gov-mod.com/assets';
    }
    if (isStaging) return 'https://update-remote-action.stg-east.frontend.public.atl-paas.net/assets';
    return 'https://update-remote-action.prod-east.frontend.public.atl-paas.net/assets';
};
const $6a42ab2e996003d0$var$RemoteActions = ()=>{
    const isStaging = (0, $kyq27.useIsStagingOrDevOrLocal)();
    const [debugModeProps, setDebugModeProps] = (0, $eJOHy.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        const props = $6a42ab2e996003d0$var$getDebugModeProps($6a42ab2e996003d0$var$getDebugModeFromLocalStorage());
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-initialize-state
        setDebugModeProps(props);
    }, []);
    const onLifecycleEvent = (0, $eJOHy.useCallback)(({ action: action, attributes: attributes })=>{
        $6a42ab2e996003d0$var$fireLifecycleAnalytics(createAnalyticsEvent({}), action, attributes);
    }, [
        createAnalyticsEvent
    ]);
    const endpointUrl = $6a42ab2e996003d0$export$c54f5a49b5be9709(isStaging, (0, $lopBx.isFedRamp)());
    const productData = (0, $eJOHy.useMemo)(()=>({
            getBuildKey: ()=>typeof window !== 'undefined' ? window.BUILD_KEY : '',
            getBuildInfoFromKey: $6a42ab2e996003d0$export$38ac5ad36585402e,
            getFeatureGateValue: (0, $4cTDP.fg),
            getFeatureFlagValue: (0, $6eHOp.ff)
        }), []);
    if (!endpointUrl || !debugModeProps) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1EoGg.default), {
        endpoint: endpointUrl,
        product: debugModeProps.product,
        productData: productData,
        pollingInterval: debugModeProps.pollingInterval,
        onLifecycleEvent: onLifecycleEvent
    });
};
var $6a42ab2e996003d0$export$2e2bcd8739ae039 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('remote_actions_-_killswitch_-_temporary'), $6a42ab2e996003d0$var$RemoteActions, ()=>null);

});
parcelRegister("6eHOp", function(module, exports) {
$parcel$export(module.exports, "getFeatureFlagValue", () => $da6d0b5f6a4027e4$export$7064bb599f663d7e);
$parcel$export(module.exports, "ff", () => $da6d0b5f6a4027e4$export$f59495b1b7502b33);
function $da6d0b5f6a4027e4$export$7064bb599f663d7e(_featureFlagName, defaultValue) {
    return defaultValue;
}
const $da6d0b5f6a4027e4$export$f59495b1b7502b33 = (_featureFlagName, defaultValue = false)=>{
    return defaultValue;
};
const $da6d0b5f6a4027e4$export$757bc67afadef4a0 = (_featureFlagName, defaultValue, _possibleValues)=>{
    return defaultValue;
};

});

parcelRegister("1EoGg", function(module, exports) {
$parcel$export(module.exports, "default", () => $f31e9f9ac426ba4b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $9uktG = parcelRequire("9uktG");

var $1oSmQ = parcelRequire("1oSmQ");

var $eKzQk = parcelRequire("eKzQk");
const $f31e9f9ac426ba4b$var$EmitAnalyticsOnNewActionsProcessed = ({ onLifecycleEvent: onLifecycleEvent })=>{
    const lastUpdatedAt = (0, $eKzQk.useRemoteActionLastUpdatedAt)();
    const remoteActionsData = (0, $eKzQk.useRemoteActionsData)();
    (0, $eJOHy.useEffect)(()=>{
        if (lastUpdatedAt > 0) onLifecycleEvent({
            action: 'pendingActions',
            attributes: {
                lastUpdatedAt: lastUpdatedAt,
                hasPendingActions: Object.keys(remoteActionsData).length > 0,
                pendingActionsIds: Object.keys(remoteActionsData)
            }
        });
    }, [
        lastUpdatedAt,
        remoteActionsData,
        onLifecycleEvent
    ]);
    return null;
};
const $f31e9f9ac426ba4b$var$RemoteActionsManagerInternal = ({ endpoint: endpoint, product: product, productData: productData, pollingInterval: pollingInterval, idleTime: idleTime, onLifecycleEvent: onLifecycleEvent })=>{
    const onPollingError = (0, $eJOHy.useCallback)(()=>{
        if (onLifecycleEvent) onLifecycleEvent({
            action: 'pollingError'
        });
    }, [
        onLifecycleEvent
    ]);
    (0, $1oSmQ.useRemoteActionsOnInterval)({
        endpoint: endpoint,
        product: product,
        productData: productData,
        pollingInterval: pollingInterval,
        idleTime: idleTime,
        onPollingError: onPollingError
    });
    return onLifecycleEvent ? /*#__PURE__*/ (0, $gt9Am.jsx)($f31e9f9ac426ba4b$var$EmitAnalyticsOnNewActionsProcessed, {
        onLifecycleEvent: onLifecycleEvent
    }) : null;
};
const $f31e9f9ac426ba4b$var$RemoteActionsManager = (props)=>{
    const { product: product, onLifecycleEvent: onLifecycleEvent } = props;
    const isLocalStorageSupportedRef = (0, $eJOHy.useRef)((0, $9uktG.isLocalStorageSupported)());
    (0, $eJOHy.useEffect)(()=>{
        if (!isLocalStorageSupportedRef.current) {
            if (onLifecycleEvent) onLifecycleEvent({
                action: 'disabled',
                attributes: {
                    reason: 'LOCALSTORAGE_UNSUPPORTED'
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!isLocalStorageSupportedRef.current) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eKzQk.RemoteActionsContainer), {
        product: product,
        isGlobal: true,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)($f31e9f9ac426ba4b$var$RemoteActionsManagerInternal, {
            ...props
        })
    });
};
var $f31e9f9ac426ba4b$export$2e2bcd8739ae039 = $f31e9f9ac426ba4b$var$RemoteActionsManager;

});
parcelRegister("9uktG", function(module, exports) {
$parcel$export(module.exports, "isLocalStorageSupported", () => $b5745c1e76aafba8$export$bd6fa5db394a4992);
// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
const $b5745c1e76aafba8$export$bd6fa5db394a4992 = ()=>{
    try {
        // use an random key to test
        const testKey = `__test_${Date.now()}__`;
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    } catch (e) {
        return false;
    }
};

});

parcelRegister("1oSmQ", function(module, exports) {
$parcel$export(module.exports, "useRemoteActionsOnInterval", () => $f0a58d4555a4edd6$export$ee582f7d4b1ff42f);

var $eJOHy = parcelRequire("eJOHy");

var $AMt3Z = parcelRequire("AMt3Z");

var $eKzQk = parcelRequire("eKzQk");
const $f0a58d4555a4edd6$export$ee582f7d4b1ff42f = ({ endpoint: endpoint, product: product, productData: productData, onPollingError: onPollingError, pollingInterval: pollingInterval, idleTime: idleTime })=>{
    const [{ isLoaded: isLoaded }, { processRemoteActions: processRemoteActions }] = (0, $eKzQk.useRemoteActions)((state)=>({
            isLoaded: state.isLoaded
        }));
    (0, $eJOHy.useEffect)(()=>{
        if (!isLoaded) return;
        const remoteActionPollingService = new (0, $AMt3Z.RemoteActionsPollingService)(endpoint, product, (response)=>{
            processRemoteActions(productData, response);
        }, onPollingError, pollingInterval, idleTime);
        return ()=>remoteActionPollingService.destroy();
    }, [
        processRemoteActions,
        isLoaded,
        product,
        productData,
        onPollingError,
        endpoint,
        pollingInterval,
        idleTime
    ]);
};

});
parcelRegister("AMt3Z", function(module, exports) {
$parcel$export(module.exports, "RemoteActionsPollingService", () => $996867a79ceee657$export$6279e159d4acc1e);

var $dVcSp = parcelRequire("dVcSp");


var $fN4Yd = parcelRequire("fN4Yd");
const $996867a79ceee657$var$createBroadcastChannel = (channelName)=>{
    try {
        // eslint-disable-next-line compat/compat
        return new BroadcastChannel(channelName);
    } catch  {
        return undefined;
    }
};
var $996867a79ceee657$export$50f695ee7ce4b786 = /*#__PURE__*/ function(PollingState) {
    PollingState["POLLING"] = "polling";
    PollingState["SUSPENDED"] = "suspended";
    PollingState["DESTROYED"] = "destroyed";
    return PollingState;
}({});
class $996867a79ceee657$export$6279e159d4acc1e {
    constructor(endpoint, product, onRemoteActionsUpdate, onPollingError, pollingInterval, idleTime){
        this.endpoint = endpoint;
        this.product = product;
        this.onRemoteActionsUpdate = onRemoteActionsUpdate;
        this.onPollingError = onPollingError;
        this.pollingState = "suspended";
        this.lastUpdateReceivedAt = Date.now();
        this.pollingInterval = pollingInterval || (0, $306a03ccf17a563a$export$f2b2f5ef0b498d26);
        this.broadcastChannel = $996867a79ceee657$var$createBroadcastChannel(`${(0, $306a03ccf17a563a$export$388bd7a7ebb11e7)}-${product}`);
        this.broadcastChannel?.addEventListener('message', (event)=>{
            if (event.data.messageType === 'remote-action-polled') {
                this.lastUpdateReceivedAt = Date.now();
                if (!this.lastResponse?.lastUpdatedAt || this.lastResponse.lastUpdatedAt < event.data.response.lastUpdatedAt) {
                    this.lastResponse = event.data.response;
                    this.onRemoteActionsUpdate(event.data.response);
                }
            }
        });
        this.intervalInstance = setInterval(()=>{
            if (this.pollingState === "polling") this.fetchRemoteActions();
        }, this.pollingInterval || (0, $306a03ccf17a563a$export$f2b2f5ef0b498d26));
        this.browserInteractionTime = new (0, $dVcSp.default)({
            idleTimeoutMs: idleTime || (0, $306a03ccf17a563a$export$af2ff676951003fe),
            stopTimerOnTabchange: false,
            browserTabActiveCallbacks: [
                this.onActive.bind(this)
            ],
            browserTabInactiveCallbacks: [
                this.onInactive.bind(this)
            ],
            activeCallbacks: [
                this.onActive.bind(this)
            ],
            idleCallbacks: [
                this.onInactive.bind(this)
            ]
        });
        this.browserInteractionTime.startTimer();
        this.start();
    }
    onActive() {
        if (this.pollingState === "suspended") this.start();
    }
    onInactive() {
        if (this.pollingState === "polling") this.suspend();
    }
    async fetchRemoteActions() {
        try {
            if (Date.now() - this.lastUpdateReceivedAt >= this.pollingInterval) {
                const response = await (0, $fN4Yd.getRemoteActions)(this.endpoint, this.product);
                if (response) {
                    this.lastUpdateReceivedAt = Date.now();
                    if (!this.lastResponse?.lastUpdatedAt || this.lastResponse?.lastUpdatedAt < response.lastUpdatedAt) {
                        this.lastResponse = response;
                        this.onRemoteActionsUpdate(response);
                    }
                    if (this.broadcastChannel) this.broadcastChannel.postMessage({
                        response: response,
                        messageType: 'remote-action-polled'
                    });
                }
            }
        } catch (error) {
            this.onPollingError(error);
        }
    }
    start() {
        if (this.pollingState === "destroyed") throw new Error('RemoteActionService instance was destroyed and cannot be started again');
        this.pollingState = "polling";
        // fetch the remote actions immediately (if the last update was more than the polling interval ago)
        this.fetchRemoteActions();
    }
    suspend() {
        this.pollingState = "suspended";
    }
    destroy() {
        if (this.pollingState !== "destroyed") {
            this.suspend();
            clearInterval(this.intervalInstance);
            this.intervalInstance = undefined;
            this.browserInteractionTime?.destroy();
            this.browserInteractionTime = undefined;
            this.broadcastChannel?.close();
            this.broadcastChannel = undefined;
            this.pollingState = "destroyed";
        }
    }
    getState() {
        return this.pollingState;
    }
}

});
const $306a03ccf17a563a$export$f2b2f5ef0b498d26 = 5000;
const $306a03ccf17a563a$export$f2c0b74311ada874 = 3;
const $306a03ccf17a563a$export$af2ff676951003fe = 60000;
const $306a03ccf17a563a$export$388bd7a7ebb11e7 = 'atlassian-remote-actions-v1';

parcelRegister("fN4Yd", function(module, exports) {
$parcel$export(module.exports, "getRemoteActions", () => $1d38606d3cab817e$export$6e23e289b6bb0154);
const $1d38606d3cab817e$var$RETRY_HTTP_CODES = [
    408,
    500,
    502,
    503,
    504,
    522,
    524
];
function $1d38606d3cab817e$var$timeout(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
async function $1d38606d3cab817e$var$fetchRetry(url, options = {}, retries = 5, backoff = 300) {
    const response = await fetch(url, options);
    if (response.ok || response.status === 401) return response;
    if (retries > 1 && $1d38606d3cab817e$var$RETRY_HTTP_CODES.includes(response.status)) {
        await $1d38606d3cab817e$var$timeout(backoff);
        return await $1d38606d3cab817e$var$fetchRetry(url, options, retries - 1, backoff * 2);
    } else throw new Error(`Failed to fetch remote actions with status ${response.status}`);
}
const $1d38606d3cab817e$var$getRemoteActionsUrlForProduct = (endpoint, product)=>`${endpoint}/${product}.json`;
const $1d38606d3cab817e$export$6e23e289b6bb0154 = async (endpoint, product)=>{
    const remoteActionsUrl = $1d38606d3cab817e$var$getRemoteActionsUrlForProduct(endpoint, product);
    const response = await $1d38606d3cab817e$var$fetchRetry(remoteActionsUrl, {
        cache: 'no-store',
        method: 'GET'
    });
    if (response && response.ok) {
        const remoteActionsResponse = await response.json();
        if (remoteActionsResponse && typeof remoteActionsResponse.lastUpdatedAt === 'number' && remoteActionsResponse.remoteActions instanceof Array) return remoteActionsResponse;
    }
};

});


parcelRegister("eKzQk", function(module, exports) {
$parcel$export(module.exports, "RemoteActionsContainer", () => $9619c367486de9a7$export$28c2e4c663a86266);
$parcel$export(module.exports, "useRemoteActions", () => $9619c367486de9a7$export$333357b3de3e67a0);
$parcel$export(module.exports, "useRemoteActionsData", () => $9619c367486de9a7$export$3cc006661ae2a759);
$parcel$export(module.exports, "useMeta", () => $9619c367486de9a7$export$3fb9275d3845bd5a);
$parcel$export(module.exports, "useRemoteActionLastUpdatedAt", () => $9619c367486de9a7$export$1d013261a2e6e0f9);
$parcel$export(module.exports, "useRemoteActionsStoreActions", () => $9619c367486de9a7$export$3fd21eaf97df4718);

var $iJq0l = parcelRequire("iJq0l");
var $6E16M = parcelRequire("6E16M");
var $GtRbT = parcelRequire("GtRbT");
var $awqaz = parcelRequire("awqaz");

var $77B4H = parcelRequire("77B4H");
// jira freezes the global defaults object
if (!Object.isFrozen((0, $awqaz.default))) (0, $awqaz.default).devtools = false;
const $9619c367486de9a7$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        meta: {},
        remoteActions: {},
        lastUpdatedAt: 0,
        isLoaded: false,
        product: undefined
    },
    actions: $77B4H.actions,
    name: 'remoteActionsStore'
});
const $9619c367486de9a7$export$28c2e4c663a86266 = (0, $6E16M.createContainer)($9619c367486de9a7$var$Store, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch((0, $77B4H.actions).initStore());
        }
});
const $9619c367486de9a7$export$333357b3de3e67a0 = (selector)=>(0, $iJq0l.createHook)($9619c367486de9a7$var$Store, {
        selector: selector
    })();
const $9619c367486de9a7$export$3cc006661ae2a759 = (0, $iJq0l.createStateHook)($9619c367486de9a7$var$Store, {
    selector: (state)=>state.remoteActions
});
const $9619c367486de9a7$export$3fb9275d3845bd5a = (0, $iJq0l.createStateHook)($9619c367486de9a7$var$Store, {
    selector: (state)=>state.meta
});
const $9619c367486de9a7$export$1d013261a2e6e0f9 = (0, $iJq0l.createStateHook)($9619c367486de9a7$var$Store, {
    selector: (state)=>state.lastUpdatedAt
});
const $9619c367486de9a7$export$3fd21eaf97df4718 = (0, $iJq0l.createActionsHook)($9619c367486de9a7$var$Store);

});
parcelRegister("77B4H", function(module, exports) {
$parcel$export(module.exports, "actions", () => $df64a07630011629$export$e324594224ef24da);

var $kFNqg = parcelRequire("kFNqg");

var $4Z6c5 = parcelRequire("4Z6c5");

var $lkKF6 = parcelRequire("lkKF6");

var $8mR35 = parcelRequire("8mR35");
const $df64a07630011629$export$e324594224ef24da = {
    processRemoteActions: $lkKF6.processRemoteActions,
    saveActionPerformedAttempt: $8mR35.saveActionPerformedAttempt,
    initStore: $4Z6c5.initStore,
    clearActionId: $kFNqg.clearActionId
};

});
parcelRegister("kFNqg", function(module, exports) {
$parcel$export(module.exports, "clearActionId", () => $08384ec3fbbfd9af$export$8d8b492eefa9efba);

var $fYmOz = parcelRequire("fYmOz");
const $08384ec3fbbfd9af$export$8d8b492eefa9efba = (actionId)=>({ getState: getState, setState: setState }, { product: product })=>{
        const { meta: meta } = getState();
        const newMeta = {
            ...meta
        };
        delete newMeta[actionId];
        setState({
            meta: newMeta
        });
        (0, $fYmOz.writeRemoteActionsMetasToLocalStorage)(product, meta);
    };

});
parcelRegister("fYmOz", function(module, exports) {
$parcel$export(module.exports, "readRemoteActionsMetasFromLocalStorage", () => $e3530a747093e38f$export$a221266a05084986);
$parcel$export(module.exports, "writeRemoteActionsMetasToLocalStorage", () => $e3530a747093e38f$export$7228aaade919a8b6);
const $e3530a747093e38f$export$b9e25d3c75cffd71 = 'atlassian-remote-actions';
const $e3530a747093e38f$export$a221266a05084986 = (product)=>{
    try {
        return JSON.parse(localStorage.getItem(`${$e3530a747093e38f$export$b9e25d3c75cffd71}.${product}`) || '{}');
    } catch (e) {
        console.warn('Could not load from localStorage', e);
        return {};
    }
};
const $e3530a747093e38f$export$7228aaade919a8b6 = (product, remoteActionsMetas)=>{
    try {
        localStorage.setItem(`${$e3530a747093e38f$export$b9e25d3c75cffd71}.${product}`, JSON.stringify(remoteActionsMetas));
    } catch (e) {
        console.warn('Could not load from localStorage', e);
    }
};

});


parcelRegister("4Z6c5", function(module, exports) {
$parcel$export(module.exports, "initStore", () => $3c3e683a3a9cc56a$export$41f27b3823a442c6);

var $fYmOz = parcelRequire("fYmOz");
const $3c3e683a3a9cc56a$export$41f27b3823a442c6 = ()=>({ setState: setState }, { product: product })=>{
        // TODO Async read from Localstorage.
        setState({
            meta: (0, $fYmOz.readRemoteActionsMetasFromLocalStorage)(product),
            isLoaded: true,
            product: product
        });
    };

});

parcelRegister("lkKF6", function(module, exports) {
$parcel$export(module.exports, "processRemoteActions", () => $73bcd93d0808b9f9$export$15e69d1dd38ccaa3);

var $7gucp = parcelRequire("7gucp");
const $73bcd93d0808b9f9$export$15e69d1dd38ccaa3 = (productData, remoteActionsResponse)=>({ getState: getState, setState: setState })=>{
        const { lastUpdatedAt: lastUpdatedAt, meta: meta } = getState();
        if (remoteActionsResponse.lastUpdatedAt <= lastUpdatedAt) // data has not been updated, nothing to do
        return;
        const remoteActions = remoteActionsResponse.remoteActions.reduce((updatedRemoteActions, remoteAction)=>{
            if ((0, $7gucp.shouldProcessRemoteAction)(remoteAction)) {
                const shouldAddAction = remoteAction.conditions.every((condition)=>(0, $7gucp.isActionConditionSatisfied)(productData, condition));
                if (shouldAddAction) updatedRemoteActions[remoteAction.id] = remoteAction;
            }
            // no updates
            return updatedRemoteActions;
        }, {});
        setState({
            // only keep the meta for the remote actions that are still present. This is to avoid
            // keeping stale meta which would otherwise grow indefinitely.
            meta: Object.keys(remoteActions).reduce((newMeta, id)=>{
                newMeta[id] = meta[id];
                return newMeta;
            }, {}),
            remoteActions: remoteActions,
            lastUpdatedAt: remoteActionsResponse.lastUpdatedAt
        });
    };

});
parcelRegister("7gucp", function(module, exports) {
$parcel$export(module.exports, "isActionConditionSatisfied", () => $4a46ee77a8d28208$export$9262d8191a70c677);
$parcel$export(module.exports, "shouldProcessRemoteAction", () => $4a46ee77a8d28208$export$c7cc93192d09a3d7);

var $3V9IP = parcelRequire("3V9IP");
const $4a46ee77a8d28208$var$isFeatureFlagConditionSatisfied = (getFeatureFlagValue, condition)=>condition.affectedFeatureFlagValue === getFeatureFlagValue(condition.featureFlagKey);
const $4a46ee77a8d28208$var$isFeatureGateConditionSatisfied = (getFeatureGateValue, condition)=>getFeatureGateValue && condition.affectedFeatureGateValue === getFeatureGateValue(condition.featureGateKey);
const $4a46ee77a8d28208$var$isBuildInAffectedRangeV2 = (getBuildKey, getBuildInfoFromKey, condition)=>{
    try {
        const { buildNumber: currentBuildNumber, buildType: currentBuildType } = getBuildInfoFromKey(getBuildKey());
        const { buildNumber: firstAffectedBuildNumber, buildType: firstAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[0]);
        const { buildNumber: lastAffectedBuildNumber, buildType: lastAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[1]);
        if (firstAffectedBuildType !== currentBuildType || lastAffectedBuildType !== currentBuildType) return false;
        if (firstAffectedBuildNumber <= currentBuildNumber && currentBuildNumber <= lastAffectedBuildNumber) return true;
    } catch (error) {
        console.warn('error while parsing a build key', error);
    }
    return false;
};
const $4a46ee77a8d28208$export$9262d8191a70c677 = (productData, condition)=>{
    switch(condition.type){
        case (0, $3V9IP.ConditionType).buildRange:
            return $4a46ee77a8d28208$var$isBuildInAffectedRangeV2(productData.getBuildKey, productData.getBuildInfoFromKey, condition);
        case (0, $3V9IP.ConditionType).featureFlag:
            return $4a46ee77a8d28208$var$isFeatureFlagConditionSatisfied(productData.getFeatureFlagValue, condition);
        case (0, $3V9IP.ConditionType).featureGate:
            return $4a46ee77a8d28208$var$isFeatureGateConditionSatisfied(productData.getFeatureGateValue, condition);
        default:
            return false;
    }
};
const $4a46ee77a8d28208$export$c7cc93192d09a3d7 = (remoteAction)=>remoteAction.enabled;

});
parcelRegister("3V9IP", function(module, exports) {
$parcel$export(module.exports, "ConditionType", () => $0bc4fcbe27213e12$export$748d1c753cdf4bfd);
var $0bc4fcbe27213e12$export$748d1c753cdf4bfd = /*#__PURE__*/ function(ConditionType) {
    ConditionType["featureFlag"] = "featureFlag";
    ConditionType["featureGate"] = "featureGate";
    ConditionType["buildRange"] = "buildRange";
    return ConditionType;
}({});

});



parcelRegister("8mR35", function(module, exports) {
$parcel$export(module.exports, "saveActionPerformedAttempt", () => $5a0483da3cb1b7ad$export$e3144a2e886e0e77);

var $fYmOz = parcelRequire("fYmOz");
const $5a0483da3cb1b7ad$export$e3144a2e886e0e77 = (actionId)=>({ getState: getState, setState: setState })=>{
        const { meta: meta, product: product } = getState();
        const currentAttemptCount = meta[actionId]?.attemptCounts || 0;
        const updatedMetas = {
            ...meta,
            [actionId]: {
                lastPerformAttemptedAt: Date.now(),
                attemptCounts: currentAttemptCount + 1
            }
        };
        setState({
            meta: updatedMetas
        });
        // Can not happen.
        if (!product) throw new Error('Product is not defined.');
        (0, $fYmOz.writeRemoteActionsMetasToLocalStorage)(product, updatedMetas);
    };

});







//# sourceMappingURL=async-remote-actions.f76a336b.js.map
